// pp-customer-dashboard.js — Recompra rápida + repetir última orden.
// Compartido por pp-customer-dashboard (sección del hub) y por la
// página dedicada pp-customer-recompra-page. Antes vivía inline en
// pp-customer-dashboard.liquid; al separar la recompra a su propia
// page el script no se cargaba ahí y los botones qty no respondían.

function ppMoney(cents) {
  var n = Math.round(cents);
  var s = (n / 100).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  return '$' + s + ' MXN';
}

// Variante para precio por pieza dentro de un paquete (ej. $0.86/bolsa,
// $44.56/caja). Reglas:
//   - Strip trailing zeros del decimal: $13.00 → $13, $11.40 → $11.4
//   - Conserva decimales no-cero: $10.55 → $10.55, $0.86 → $0.86
//   - SIN " MXN" (el c/u ya tiene la moneda; el /pieza es sufijo compacto)
//   - Comma separator para miles (formato es-MX)
function ppMoneyPiece(cents) {
  var amount = cents / 100;
  var s = amount.toFixed(2);
  // Strip trailing zeros: "13.00" → "13", "11.40" → "11.4", "10.55" → "10.55"
  s = s.replace(/\.?0+$/, '');
  // Comma separator para miles: "1234.5" → "1,234.5"
  var parts = s.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return '$' + parts.join('.');
}

// Aplica el mejor tier de descuento por volumen al qty dado.
// tiersJson: '[{"min":4,"off":15},{"min":8,"off":22}]' — ya emitido
// por el snippet pp-volume-rules en data-volume-tiers.
function ppApplyTier(unitPrice, qty, tiersJson) {
  if (!tiersJson) return { price: unitPrice, off: 0 };
  var tiers;
  try { tiers = JSON.parse(tiersJson); } catch (_) { return { price: unitPrice, off: 0 }; }
  if (!Array.isArray(tiers) || tiers.length === 0) return { price: unitPrice, off: 0 };
  var bestOff = 0;
  tiers.forEach(function (t) {
    if (qty >= t.min && t.off > bestOff) bestOff = t.off;
  });
  if (bestOff === 0) return { price: unitPrice, off: 0 };
  return { price: Math.round(unitPrice * (100 - bestOff) / 100), off: bestOff };
}

function ppIsItemExcluded(item) {
  var check = item.querySelector('[data-pp-reorder-check]');
  return check ? !check.checked : false;
}

function ppRecalcReorder() {
  var subtotalEl = document.querySelector('[data-pp-reorder-subtotal]');
  if (!subtotalEl) return;
  var items = document.querySelectorAll('[data-pp-reorder-item]');
  var subtotal = 0;
  var subtotalFull = 0;
  items.forEach(function (item) {
    var unit = parseFloat(item.getAttribute('data-unit-price')) || 0;
    var tiersJson = item.getAttribute('data-volume-tiers') || '';
    var input = item.querySelector('input[type="number"]');
    var qty = input ? (parseInt(input.value, 10) || 0) : 0;
    var applied = ppApplyTier(unit, qty, tiersJson);
    var lineTotal = applied.price * qty;
    var lineTotalFull = unit * qty;
    var excluded = ppIsItemExcluded(item);

    var lineEl = item.querySelector('[data-pp-reorder-line-price]');
    if (lineEl) lineEl.textContent = ppMoney(lineTotal);

    // Subtotal de línea sin descuento (tachado) — visible solo cuando
    // el tier de volumen está aplicando un % off > 0.
    var lineWasEl = item.querySelector('[data-pp-reorder-line-price-was]');
    if (lineWasEl) {
      if (applied.off > 0) {
        lineWasEl.textContent = ppMoney(lineTotalFull);
        lineWasEl.hidden = false;
      } else {
        lineWasEl.hidden = true;
      }
    }

    var unitEl = item.querySelector('[data-pp-reorder-unit-display]');
    if (unitEl) unitEl.textContent = ppMoney(applied.price);

    // Precio por pieza dentro del paquete (ej. $0.86/bolsa) — solo
    // productos con pack_size > 1 (data-pack-size del Liquid).
    var pieceEl = item.querySelector('[data-pp-reorder-unit-piece]');
    if (pieceEl) {
      var packSize = parseInt(item.getAttribute('data-pack-size'), 10) || 0;
      if (packSize > 1) {
        pieceEl.textContent = ppMoneyPiece(applied.price / packSize);
      }
    }

    var discEl = item.querySelector('[data-pp-reorder-discount]');
    if (discEl) {
      if (applied.off > 0) {
        discEl.textContent = '−' + Math.round(applied.off) + '%';
        discEl.hidden = false;
      } else {
        discEl.textContent = '';
        discEl.hidden = true;
      }
    }

    // Solo sumar al subtotal si el item está incluido (checkbox checked).
    // Excluidos mantienen su qty visible pero no participan en el total
    // ni en el batch del "Agregar todo al carrito".
    if (!excluded) {
      subtotal += lineTotal;
      subtotalFull += lineTotalFull;
    }
  });
  subtotalEl.textContent = ppMoney(subtotal);

  // Subtotal estimado sin descuento (tachado) — visible solo si la
  // suma con tiers difiere del full (≥ 1 ítem con tier aplicado).
  var subtotalWasEl = document.querySelector('[data-pp-reorder-subtotal-was]');
  if (subtotalWasEl) {
    if (subtotalFull > subtotal) {
      subtotalWasEl.textContent = ppMoney(subtotalFull);
      subtotalWasEl.hidden = false;
    } else {
      subtotalWasEl.hidden = true;
    }
  }
}

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-qty]');
  if (!btn) return;
  var item = btn.closest('.pp-dash__reorder-item');
  if (!item) return;
  var input = item.querySelector('input[type="number"]');
  if (!input) return;
  var delta = btn.getAttribute('data-qty') === '+' ? 1 : -1;
  var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
  input.value = next;
  ppRecalcReorder();
});

document.addEventListener('input', function (e) {
  if (!e.target.matches('.pp-dash__reorder-item input[type="number"]')) return;
  ppRecalcReorder();
});

// Agregar todo al carrito → POST /cart/add.js batch
// Toggle del checkbox de "incluir en pedido": marca la row como excluida
// visualmente (opacity), deshabilita el qty stepper y recalcula subtotal.
document.addEventListener('change', function (e) {
  if (!e.target.matches('[data-pp-reorder-check]')) return;
  var item = e.target.closest('.pp-dash__reorder-item');
  if (!item) return;
  if (e.target.checked) {
    item.classList.remove('is-excluded');
  } else {
    item.classList.add('is-excluded');
  }
  ppRecalcReorder();
});

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-pp-reorder-add-all]');
  if (!btn) return;
  var items = document.querySelectorAll('[data-pp-reorder-item]');
  var payload = [];
  items.forEach(function (item) {
    // Skipear items con checkbox desmarcado (excluidos del pedido)
    if (ppIsItemExcluded(item)) return;
    var id = parseInt(item.getAttribute('data-variant-id'), 10);
    var input = item.querySelector('input[type="number"]');
    var qty = input ? (parseInt(input.value, 10) || 0) : 0;
    if (id && qty > 0) payload.push({ id: id, quantity: qty });
  });
  if (payload.length === 0) {
    alert('Sube la cantidad de al menos un producto antes de agregar al carrito.');
    return;
  }
  var origText = btn.textContent.trim();
  btn.disabled = true;
  btn.textContent = 'Agregando…';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: payload })
  })
    .then(function (res) {
      if (res.status === 422) {
        return Promise.all(payload.map(function (it) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [it] })
          }).catch(function () { return null; });
        }));
      }
      return res;
    })
    .then(function () { window.location.href = '/cart'; })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = origText;
      alert('No pudimos agregar los productos. Intenta de nuevo.');
    });
});

// Normalizar todos los precios al cargar la página. El initial render
// del Liquid puede tener pequeñas discrepancias con la fórmula del JS
// (redondeos, money_without_trailing_zeros vs money, etc.). Llamando
// ppRecalcReorder al boot garantizamos un único source of truth (JS) —
// si no, al primer click del qty stepper los valores "saltan" porque
// JS toma control con su propio formato.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ppRecalcReorder);
} else {
  ppRecalcReorder();
}

// ── Repetir última orden ──────────────────────────────────────
// Lee data-pp-reorder-items con formato "variant_id:qty,variant_id:qty,..."
// y POSTea a /cart/add.js como single batch. Skipea variantes inválidas
// (producto borrado, sin stock) con error silencioso. Redirige a /cart al
// terminar para que el cliente revise.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-pp-reorder-last]');
  if (!btn) return;
  e.preventDefault();
  // 6-oct-2026: si la última orden traía algo personalizado, se repite en
  // «Compra Rápida», donde el cliente confirma su diseño antes de agregarlo.
  var ir = btn.getAttribute('data-pp-reorder-ir');
  if (ir) { window.location.href = ir; return; }
  var raw = btn.getAttribute('data-pp-reorder-items') || '';
  if (!raw) return;
  var items = raw.split(',').map(function (pair) {
    var parts = pair.split(':');
    var id = parseInt(parts[0], 10);
    var qty = parseInt(parts[1], 10) || 1;
    return id ? { id: id, quantity: qty } : null;
  }).filter(Boolean);
  if (items.length === 0) return;

  var origText = btn.textContent.trim();
  btn.disabled = true;
  btn.textContent = 'Agregando…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
    .then(function (res) {
      if (res.status === 422) {
        return Promise.all(items.map(function (it) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [it] })
          }).catch(function () { return null; });
        }));
      }
      return res;
    })
    .then(function () { window.location.href = '/cart'; })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = origText;
      alert('No pudimos repetir la orden completa. Intenta de nuevo o agrega los productos manualmente.');
    });
});
